import React from "react";
import { Card } from "react-bootstrap";

const DocumentiPlayer = () => {
    return (
        <>
            <Card>
                <Card.Header>Documenti</Card.Header>
                <Card.Body>
                    <div className="m-5 text-center">Coming soon</div>
                </Card.Body>
            </Card>
        </>
    )
}
export default DocumentiPlayer;
